import React from 'react';
import { Checkbox, DisplayText } from '@superops/ui-design-system';
import type { CheckBoxFieldProps } from '../../types/interface';
import { DeviceTypeBadges } from '../DeviceTypeBadges';
import { getTranslatedText } from '@nile/components';
import { getMarginLeft } from '../../utils/MdmUtils';

const CheckBoxField = ({
  intl,
  label,
  checked,
  onChange,
  disabled = false,
  level,
  supportedDeviceTypes = [],
  showDeviceTypeBadges = false,
  isParentSectionHovered = false,
  attributeDescription = '',
  isChildAttribute = false,
  fieldId,
  minOsVersion
}: CheckBoxFieldProps) => {
  const shouldShowBadge =
    showDeviceTypeBadges && supportedDeviceTypes.length > 0;
  // Create unique ID by combining fieldId (if available) with label
  const checkboxId = `checkbox-${fieldId ? `${fieldId}-` : ''}${label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div
      className={`flex g10 min-h-32 ${getMarginLeft(level)} ${attributeDescription ? 'astart' : 'actr'}`}
    >
      <div className={`${attributeDescription ? 'pt-2' : ''}`}>
        <Checkbox
          id={checkboxId}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
      <div className="flex col">
        <div className="flex g10 min-h-22">
          <label htmlFor={checkboxId} className={disabled ? 'cursor-default' : 'pointer'}>
            <DisplayText
              element="p"
              size="large"
              weight="Medium"
            >
              {getTranslatedText(intl, label)}
            </DisplayText>
          </label>
          <DeviceTypeBadges
            intl={intl}
            supportedDeviceTypes={supportedDeviceTypes}
            shouldShow={shouldShowBadge && isParentSectionHovered}
          />
        </div>
        {attributeDescription && (
          <DisplayText
            element="p"
            size="medium"
            variant="subdued"
          >
            {getTranslatedText(intl, attributeDescription, { minOsVersion })}
          </DisplayText>
        )}
      </div>
    </div>
  );
};

export default CheckBoxField;
